import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import React from 'react';

interface Props {
  title: string;
  description: string;
  renderSupportAction?: (description: string) => React.ReactNode;
  errorDescription: string;
}

const ErrorBoundaryContainer: React.FC<Props> = ({ title, description, renderSupportAction, errorDescription }) => (
  <Container
    sx={{
      justifyContent: 'center',
      minHeight: 'calc(100vh - 90px)',
      display: 'flex',
      alignItems: 'center',
    }}
  >
    <Typography variant="display0" sx={{ float: 'left' }} mr={3.75} color="primary">
      Oops...
    </Typography>

    <div>
      <Typography variant="h4" mb={1} pt={1.5}>
        {title}
      </Typography>

      <Typography color="textSecondary" mb={1.5}>
        {description}
      </Typography>

      {renderSupportAction?.(errorDescription) || null}
    </div>
  </Container>
);

export default ErrorBoundaryContainer;
